import { useQueryClient, useMutation, useQuery } from 'react-query'

import { Report2CreateFormTypes, } from "schemas/reports-#-2-schemas";
import { postReport2Service } from "api/reports-#-2";

export const useReport2Query = (payload: Report2CreateFormTypes) => {
  const query = useQuery({
    refetchOnWindowFocus: false,
    queryKey: ['useReport2Query', payload],
    queryFn: async () => {
      return await postReport2Service(payload);
    },
  })
  
  return query;
}


export const useReport2Mutation = () => {
  // const queryClient = useQueryClient();
  
  const mutationFn = async (payload: Report2CreateFormTypes) => {
    return await postReport2Service(payload);
  };

  const mutation = useMutation({
    mutationFn,
    // onError: (error: string) => {},
    // onSuccess: (data) => {},
  });

  return mutation;
};
